import { useEffect } from 'react';
import Script from 'next/script';
import parse from 'html-react-parser';
import styles from './trustPilotReviews.module.scss';

export default function TrustPilotReviews({ headline, subHeadline }) {
  useEffect(() => {
    const interval = setInterval(() => {
      if (window.Trustpilot && window.Trustpilot.loadFromElement) {
        const el = document.getElementById('trustbox-carousel');
        if (el) {
          window.Trustpilot.loadFromElement(el, true);
          clearInterval(interval);
        }
      }
    }, 300);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* <!-- TrustBox script --> */}
      <Script
        type="text/javascript"
        src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        async
        strategy="afterInteractive"
      />
      {/* <!-- End TrustBox script --> */}
      <div>
        {headline && <div className={styles.headline}>{parse(headline)}</div>}
        {subHeadline && (
          <div className={styles.subHeadline}>{parse(subHeadline)}</div>
        )}
        <div
          id="trustbox-carousel"
          className="trustpilot-widget"
          data-locale="en-US"
          data-template-id="53aa8912dec7e10d38f59f36"
          data-businessunit-id="5060f52a00006400051bf99f"
          data-style-height="140px"
          data-style-width="100%"
          data-token="81a242c5-7774-4d31-8579-2a1b8f500700"
          data-stars="4,5"
          data-review-languages="en"
        />
      </div>
    </>
  );
}
